const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

class FooterNewsletter extends HTMLElement {
  constructor() {
    super()
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  connectedCallback() {
    this.form = this.querySelector('form')
    this.input = this.querySelector('.js-footer-newsletter-input')
    this.status = this.querySelector('.js-footer-newsletter-status')
    this.listId = this.dataset.listId
    this.companyId = this.dataset.companyId || window.klaviyoCompanyId
    this.source = this.dataset.source || 'Footer Newsletter'

    if (this.form) {
      this.form.addEventListener('submit', this.handleSubmit)
    }
  }

  disconnectedCallback() {
    if (this.form) {
      this.form.removeEventListener('submit', this.handleSubmit)
    }
  }

  setStatus(message, type) {
    if (!this.status) return
    this.status.textContent = message || ''
    this.status.dataset.state = type || ''
  }

  async handleSubmit(event) {
    event.preventDefault()

    const email = (this.input.value || '').trim()

    if (!EMAIL_PATTERN.test(email)) {
      this.setStatus(this.dataset.invalidText, 'error')
      this.input.focus()
      return
    }

    if (!this.companyId || !this.listId) {
      console.error('Footer newsletter: missing Klaviyo companyId or listId')
      this.setStatus(this.dataset.errorText, 'error')
      return
    }

    this.setAttribute('loading', 'true')
    this.setStatus('', '')

    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: this.source,
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email },
            },
          },
        },
        relationships: {
          list: {
            data: { type: 'list', id: this.listId },
          },
        },
      },
    }

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${this.companyId}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2024-06-15',
          },
          body: JSON.stringify(payload),
        }
      )

      if (!response.ok) {
        throw new Error(`Klaviyo subscribe request failed: ${response.status}`)
      }

      window._klOnsite = window._klOnsite || []
      window._klOnsite.push(['identify', { email: email }])

      this.form.reset()
      this.setStatus(this.dataset.successText, 'success')
    } catch (error) {
      console.error(error)
      this.setStatus(this.dataset.errorText, 'error')
    } finally {
      this.removeAttribute('loading')
    }
  }
}

window.customElements.define('footer-newsletter', FooterNewsletter)
